import { BaseApi } from "../base";

export default class TimezoneApi extends BaseApi {
  protected readonly prefix = "timeZones";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch = () => this.get("");
}
